// import { Box } from '@mui/material';
// import styles from '../../styles/helpers.module.css';

// const GradientBlobsLayer = () => {
//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         pointerEvents: 'none',
//         zIndex: 0,
//         overflow: 'hidden',
//       }}
//     >
//       <Box
//         className={styles.gradientBlob}
//         sx={{
//           width: '400px',
//           height: '400px',
//           background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
//           top: '10%',
//           left: '10%',
//           animationDelay: '0s',
//         }}
//       />
//       <Box
//         className={styles.gradientBlob}
//         sx={{
//           width: '300px',
//           height: '300px',
//           background: 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 100%)',
//           top: '60%',
//           right: '10%',
//           animationDelay: '5s',
//         }}
//       />
//       <Box
//         className={styles.gradientBlob}
//         sx={{
//           width: '350px',
//           height: '350px',
//           background: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)',
//           bottom: '10%',
//           left: '50%',
//           animationDelay: '10s',
//         }}
//       />
//     </Box>
//   );
// };

// export default GradientBlobsLayer;

import React, { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

function GradientBlobsLayer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  
  const blob1 =
    theme?.custom?.layers?.gradientBlob ??
    'radial-gradient(circle at 30% 30%, rgba(168,85,247,.6), rgba(168,85,247,0) 60%)';
  const blob2 =
    theme?.custom?.layers?.gradientBlobAlt ??
    'radial-gradient(circle at 70% 70%, rgba(236,72,153,.55), rgba(236,72,153,0) 60%)';

  // Reduce blur and size on mobile for better performance
  const blur1 = isMobile ? 20 : 30;
  const blur2 = isMobile ? 22 : 32;
  const size1 = isMobile ? 280 : 420;
  const size2 = isMobile ? 350 : 520;

  // Simplify animations on mobile or if reduced motion is preferred
  const animation1 = prefersReducedMotion 
    ? {} 
    : isMobile 
    ? { opacity: 0.5 } 
    : { opacity: 0.6, y: [0, -12, 0] };
  
  const animation2 = prefersReducedMotion
    ? {}
    : isMobile
    ? { opacity: 0.3 }
    : { opacity: [0.25, 0.45, 0.25], y: [0, 10, 0] };

  const transition1 = prefersReducedMotion 
    ? {} 
    : isMobile 
    ? { duration: 12, repeat: Infinity } 
    : { duration: 8, repeat: Infinity };
  
  const transition2 = prefersReducedMotion
    ? {}
    : isMobile
    ? { duration: 14, repeat: Infinity }
    : { duration: 10, repeat: Infinity };

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={animation1}
        transition={transition1}
        style={{
          position: 'absolute',
          width: size1,
          height: size1,
          right: isMobile ? -80 : -120,
          top: isMobile ? -100 : -140,
          background: blob1,
          filter: `blur(${blur1}px)`,
          borderRadius: 999,
          willChange: 'transform, opacity',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
        }}
      />
      <motion.div
        animate={animation2}
        transition={transition2}
        style={{
          position: 'absolute',
          width: size2,
          height: size2,
          left: isMobile ? -120 : -180,
          bottom: isMobile ? -120 : -180,
          background: blob2,
          filter: `blur(${blur2}px)`,
          borderRadius: 999,
          willChange: 'transform, opacity',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
          WebkitBackfaceVisibility: 'hidden',
        }}
      />
    </>
  );
}

export default memo(GradientBlobsLayer);
